import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Partner, PartnerInstitutional } from './Partner';
import 'swiper/css';
import 'swiper/css/free-mode';
import { useTranslation } from 'react-i18next';
import { Autoplay, FreeMode } from 'swiper';
import PartnersBG from '../../assets/images/partners_bg.svg';

// COUNCIL
import Logo_MRDM from '../../assets/images/partners_logo/mrdm.jpg';
import Logo_MRW from '../../assets/images/partners_logo/mrw.png';
import Logo_MRKK from '../../assets/images/partners_logo/mrmkk.png';
import Logo_MRMRZ from '../../assets/images/partners_logo/mrmrz.jpg';
import Logo_MRML from '../../assets/images/partners_logo/mrml.png';
import Logo_MRDB from '../../assets/images/partners_logo/mrdb.png';
import Logo_MRMP from '../../assets/images/partners_logo/mrmp.jpg';
import Logo_MRMS from '../../assets/images/partners_logo/mrms.png';
import Logo_MRDW from '../../assets/images/partners_logo/mrdw.png';
import Logo_MRDPP from '../../assets/images/partners_logo/mrdpp.png';
import Logo_MRMO from '../../assets/images/partners_logo/mrmo.jpg';
import Logo_MRPG from '../../assets/images/partners_logo/mrpg.png';
import Logo_MRDU from '../../assets/images/partners_logo/mrdu.jpeg';

// INSTITUTIONS
import Logo_PRZ from '../../assets/images/partners_logo/PRZ.png';
import Logo_PW from '../../assets/images/partners_logo/PW.jpg';
import Logo_UW from '../../assets/images/partners_logo/UW.png';
import Logo_UTH from '../../assets/images/partners_logo/UTH.jpg';

// PARTNERS
import Logo_MAKATA from '../../assets/images/partners_logo/MAKATA_STUDIO.png';
import Logo_RiF from '../../assets/images/partners_logo/RiF.png';
import Logo_MANUFAKTURA from '../../assets/images/partners_logo/MANUFAKTURA_CUKIERKOW.png';
import Logo_KADR from '../../assets/images/partners_logo/KADR.png';

// SPONSORS
import Logo_WARSZAWA from '../../assets/images/partners_logo/Warszawa.png';
import Logo_KIK from '../../assets/images/partners_logo/KIK.png';
import { Link } from 'react-router-dom';

export default function Partners() {
    const { t } = useTranslation();

    const largeBreakpoints = {
        640: {
            slidesPerView: 1,
        },
        1024: {
            slidesPerView: 2,
        },
        1280: {
            slidesPerView: 3,
        },
        1536: {
            slidesPerView: 4,
        },
    };

    const standardBreakpoints = {
        640: {
            slidesPerView: 1,
        },
        1024: {
            slidesPerView: 2,
        },
        1280: {
            slidesPerView: 3,
        },
        1536: {
            slidesPerView: 4,
        },
    };

    const sponsorsBreakpoints = {
        640: {
            slidesPerView: 1,
        },
        1024: {
            slidesPerView: 2,
        },
    };

    const youthCouncils = [
        {
            name: 'MRDM',
            logo: Logo_MRDM,
            link: 'https://www.facebook.com/mokotowmrd/',
            max: false,
        },
        {
            name: 'Młodzieżowa Rada m.st. Warszawy',
            logo: Logo_MRW,
            link: 'https://www.facebook.com/mrmwarszawa/',
            max: false,
        },
        {
            name: 'Młodzieżowa Rada Miasta Kędzierzyn-Koźle',
            logo: Logo_MRKK,
            link: 'https://www.facebook.com/MRMKKozle',
            max: false,
        },
        {
            name: 'Młodzieżowa Rada Miejska w Rabce-Zdroju',
            logo: Logo_MRMRZ,
            link: 'https://www.facebook.com/mrmrabkazdroj',
            max: false,
        },
        {
            name: 'Młodzieżowa Rada Miejska w Łodzi',
            logo: Logo_MRML,
            link: 'https://www.facebook.com/M%C5%82odzie%C5%BCowa-Rada-Miejska-w-%C5%81odzi-103807878787439',
            max: false,
        },
        {
            name: 'Młodzieżowa Rada Dzielnicy Bielany',
            logo: Logo_MRDB,
            link: 'https://www.facebook.com/mlodziezowaradabielan',
            max: false,
        },
        {
            name: 'Młodzieżowa Rada Miasta Płocka',
            logo: Logo_MRMP,
            link: 'https://www.facebook.com/MRMPlocka',
            max: false,
        },
        {
            name: 'Młodzieżowa Rada Miasta Szczecin',
            logo: Logo_MRMS,
            link: 'https://www.facebook.com/MRMSzczecin',
            max: false,
        },
        {
            name: 'Młodzieżowa Rada Dzielnicy Wawer',
            logo: Logo_MRDW,
            link: 'https://www.facebook.com/mrdwawer/',
            max: false,
        },
        {
            name: 'Młodzieżowa Rada Dzielnicy Praga-Południe',
            logo: Logo_MRDPP,
            link: 'https://www.facebook.com/pragapoludnie.mrd',
            max: false,
        },
        {
            name: 'Młodzieżowa Rada Miasta Ostrołęka',
            logo: Logo_MRMO,
            link: 'https://www.facebook.com/mrmostroleka',
            max: false,
        },
        {
            name: 'Młodzieżowa Rada Powiatu Głogowskiego',
            logo: Logo_MRPG,
            link: 'https://www.facebook.com/profile.php?id=100075932854088',
            max: false,
        },
        {
            name: 'Młodzieżowa Rada Dzielnicy Ursynów',
            logo: Logo_MRDU,
            link: 'https://www.facebook.com/MRDU.Ursynow/',
            max: false,
        },
    ];

    const institutionalPartners = [
        {
            name: 'Politechnika Rzeszowska im. Ignacego Łukasiewicza',
            logo: Logo_PRZ,
            link: 'https://w.prz.edu.pl/',
            class: 'PR',
            max: false,
        },
        {
            name: 'Politechnika Warszawska',
            logo: Logo_PW,
            class: 'PW',
            link: 'https://www.pw.edu.pl/',
            max: false,
        },
        {
            name: 'Uniwersytet warszawski',
            logo: Logo_UW,
            class: 'UW',
            link: 'https://www.uw.edu.pl/',
            max: false,
        },
        {
            name: 'Uczelnia Techniczno-Handlowa im. Heleny Chodkowskiej',
            logo: Logo_UTH,
            class: 'UTH',
            link: 'https://www.uth.edu.pl/',
            max: false,
        },
    ];

    const sponsors = [
        {
            name: 'Projekt finansowany przez m. st. Warszawa.',
            logo: Logo_WARSZAWA,
            link: 'https://um.warszawa.pl/',
            max: false,
        },
        {
            name: 'Projekt wspierany przez KIK',
            logo: Logo_KIK,
            link: 'https://donate.kik.waw.pl/pl',
            max: false,
        },
    ];
    const partners = [
        {
            name: 'Makata Studio',
            logo: Logo_MAKATA,
            link: 'https://www.facebook.com/studioMAKATA',
            max: false,
        },
        {
            name: 'RiF Robots',
            logo: Logo_RiF,
            link: 'https://rif.sklep.pl/pl/',
            max: false,
        },
        {
            name: 'Manufaktura Cukierków',
            logo: Logo_MANUFAKTURA,
            link: 'https://www.manufaktura-cukierkow.pl/pl/',
            max: false,
        },
        {
            name: 'Dom kultury Kadr',
            logo: Logo_KADR,
            link: 'https://www.dkkadr.waw.pl/',
            max: false,
        },
    ];

    return (
        <>
            <div
                className={'h-visible flex flex-col justify-center bg-cover'}
                style={{ backgroundImage: `url(${PartnersBG})` }}>
                <div className={'margin mt-24 max-w-3xl'}>
                    <h1 className={'text-4xl font-medium text-white sm:text-5xl'}>
                        {t('translation:PARTNERS.OUR_PARTNERS')}
                    </h1>
                    <p className={'my-4 text-lg text-white sm:text-2xl'}>
                        {t('translation:PARTNERS.PARTNERS_DESCRIPTION')}
                    </p>
                    <Link to={'/partnership'}>
                        <button
                            className={
                                'btn-outlined border-SM-yellow text-white hover:bg-SM-yellow  '
                            }>
                            {t('translation:PARTNERS.BE_PARTNER')}
                        </button>
                    </Link>
                </div>
            </div>
            <div className={'margin'}>
                <div className={'my-10'}>
                    <div className={'mb-2 flex flex-col items-center'}>
                        <h2 className={'mb-1 text-center text-3xl font-medium'}>
                            {t('translation:PARTNERS.INSTITUTIONAL_PARTNERS')}
                        </h2>
                        <div className={'h-1 w-64 rounded-full bg-SM-yellow'} />
                    </div>

                    <Swiper
                        freeMode={true}
                        breakpoints={largeBreakpoints}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        speed={1000}
                        loop={true}
                        modules={[Autoplay, FreeMode]}>
                        {institutionalPartners.map((partner) => {
                            return (
                                <SwiperSlide
                                    key={partner.name}
                                    className={'flex items-center justify-center p-6'}>
                                    <PartnerInstitutional
                                        name={partner.name}
                                        img={partner.logo}
                                        link={partner.link}
                                    />
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>

                <div className={'my-10 sm:mx-32'}>
                    <div className={'mb-2 flex flex-col items-center'}>
                        <h2 className={'mb-1 text-center text-3xl font-medium'}>
                            {t('translation:PARTNERS.PARTNERS')}
                        </h2>
                        <div className={'h-1 w-64 rounded-full bg-SM-yellow'} />
                    </div>

                    <Swiper
                        freeMode={true}
                        breakpoints={standardBreakpoints}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        speed={1000}
                        loop={true}
                        modules={[Autoplay, FreeMode]}>
                        {partners.map((partner) => {
                            return (
                                <SwiperSlide
                                    key={partner.name}
                                    className={'flex items-center justify-center p-6'}>
                                    <Partner
                                        img={partner.logo}
                                        name={partner.name}
                                        link={partner.link}
                                    />
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>

                <div className={'my-10 sm:mx-32'}>
                    <div className={'mb-2 flex flex-col items-center'}>
                        <h2 className={'mb-1 text-center text-3xl font-medium'}>
                            {t('translation:PARTNERS.YOUTH_COUNCILS')}
                        </h2>
                        <div className={'h-1 w-64 rounded-full bg-SM-yellow'} />
                    </div>

                    <Swiper
                        freeMode={true}
                        breakpoints={standardBreakpoints}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        speed={1000}
                        loop={true}
                        modules={[Autoplay, FreeMode]}>
                        {youthCouncils.map((partner) => {
                            return (
                                <SwiperSlide
                                    key={partner.name}
                                    className={'flex items-center justify-center p-6'}>
                                    <Partner
                                        img={partner.logo}
                                        name={partner.name}
                                        link={partner.link}
                                    />
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                    <p className={'my-4 text-center text-xs'}>
                        Strona internetowa jest realizowana w ramach projektu "Sprawne Miasto"
                        wspieranego w ramach konkursu Mam Pomysł i programu Aktywna Warszawska
                        Młodzież finansowanych przez m. st. Warszawa.
                    </p>
                    <div className={'2xl:mx-16'}>
                        <Swiper
                            freeMode={true}
                            breakpoints={sponsorsBreakpoints}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            speed={1000}
                            modules={[Autoplay, FreeMode]}>
                            {sponsors.map((partner) => {
                                return (
                                    <SwiperSlide
                                        key={partner.name}
                                        className={'flex items-center justify-center p-6'}>
                                        <Partner
                                            img={partner.logo}
                                            name={partner.name}
                                            link={partner.link}
                                        />
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    </div>
                </div>
            </div>
        </>
    );
}
